export const documents = Object.freeze({
  PRODUCTS: 'products',
  RECEPTIONS: 'receptions',
  USERS: 'users',
  AUCTIONS: 'auctions',
  CATEGORIES: 'categories',
  TAGS: 'tags',
})
